import InventoryBalanceChart from "@components/graphs/InventoryBalanceChart";

interface InventoryResultsProps {
  projectId: number;
  selectedActivities?: number[];
}

const InventoryResults = ({
  projectId,
  selectedActivities,
}: InventoryResultsProps) => {
  return (
    <InventoryBalanceChart
      projectId={projectId}
      selectedActivities={selectedActivities}
      height={300}
    />
  );
};

export default InventoryResults;
